"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPageReceiver = void 0;
var tslib_1 = require("tslib");
var consola_1 = tslib_1.__importDefault(require("consola"));
var core_1 = require("@drapejs/core");
var invoker_1 = require("@drapejs/invoker");
var index_1 = require("./index");
var batch_query_1 = require("./batch-query");
var graphql_request_1 = require("graphql-request");
exports.fetchPageReceiver = (0, invoker_1.defineReceiver)(core_1.fetchPage, function (command, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = !command.fetchFromCacheKey;
                    if (_a) return [3 /*break*/, 3];
                    _b = command.fetchFromCacheKey;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, this.cache.getItem(command.fetchFromCacheKey)];
                case 1:
                    _b = !(_c.sent());
                    _c.label = 2;
                case 2:
                    _a = (_b);
                    _c.label = 3;
                case 3:
                    if (!_a) return [3 /*break*/, 5];
                    return [4 /*yield*/, this.invoke(batch_query_1.scheduleQuery, {
                            query: (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["page(path: $path) {\n        systemId\n        type: template\n        blocks\n        fields\n        dataJson\n        canonical\n        http_location: redirectUrl\n        robots\n        http_status: statusCode\n        ", "\n      }"], ["page(path: $path) {\n        systemId\n        type: template\n        blocks\n        fields\n        dataJson\n        canonical\n        http_location: redirectUrl\n        robots\n        http_status: statusCode\n        ", "\n      }"])), (0, index_1.getCustomFields)().fetchPage || ''),
                            cacheKey: command.fetchFromCacheKey || command.cacheKey,
                            variables: {
                                path: {
                                    type: 'String!',
                                    value: command.path
                                }
                            }
                        })];
                case 4:
                    _c.sent();
                    consola_1.default.log("Fetching page data for key '".concat(command.cacheKey, "' from Litium"));
                    return [3 /*break*/, 6];
                case 5:
                    consola_1.default.log("Fetched page data for page '".concat(command.fetchFromCacheKey, "' from CACHE"));
                    _c.label = 6;
                case 6: return [4 /*yield*/, (0, batch_query_1.batchQuery)(this.cache, "".concat(command.protocol, "//").concat(command.host).concat(command.path))];
                case 7:
                    _c.sent();
                    return [4 /*yield*/, this.cache.getItem(command.fetchFromCacheKey || command.cacheKey)];
                case 8: return [2 /*return*/, _c.sent()];
            }
        });
    });
}, 'litium');
var templateObject_1;
//# sourceMappingURL=websites.js.map